import { render, staticRenderFns } from "./MenuQuickLinks.vue?vue&type=template&id=93c4b29c&scoped=true&"
import script from "./MenuQuickLinks.vue?vue&type=script&lang=ts&"
export * from "./MenuQuickLinks.vue?vue&type=script&lang=ts&"
import style0 from "./MenuQuickLinks.vue?vue&type=style&index=0&id=93c4b29c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c4b29c",
  null
  
)

export default component.exports